import { SET_SHOW_COLLAPSED_PRICING_FOR_DR } from '../actions/types';

const initialState = false;

export default function showCollapsedPricingForDr(
	state = initialState,
	action
) {
	if (action.payload) {
		switch (action.type) {
			case SET_SHOW_COLLAPSED_PRICING_FOR_DR:
				return action.payload;
			default:
		}
	}
	return state;
}
